import type { Hero } from '../types';
import { canAssignTeamToDistinctLanes } from '../utils/laneAssignment';

export type LaneFilterMode = 'smart' | 'manual' | string[];

/**
 * レーンフィルタ（スマートは二部マッチングによる割り当て可能性）
 */
export function filterHeroesByLaneMode(
  heroes: Hero[],
  allyHeroes: Hero[],
  enemyHeroes: Hero[],
  filterMode: LaneFilterMode,
  smartTargetTeam: 'ally' | 'enemy'
): Hero[] {
  const selectedIds = new Set([
    ...allyHeroes.map(h => h.id),
    ...enemyHeroes.map(h => h.id),
  ]);

  let filtered = heroes.filter(h => !selectedIds.has(h.id));

  if (filterMode === 'smart') {
    const targetTeam = smartTargetTeam === 'ally' ? allyHeroes : enemyHeroes;
    filtered = filtered.filter(h =>
      canAssignTeamToDistinctLanes([...targetTeam, h])
    );
  } else if (Array.isArray(filterMode) && filterMode.length > 0) {
    const selectedLanes = new Set(filterMode);
    filtered = filtered.filter(hero =>
      hero.lanes.some(lane => selectedLanes.has(lane))
    );
  }

  return filtered;
}
